import React, { useCallback } from 'react';
import { Box, Button, Typography } from '@mui/material';
import classNames from 'classnames';
import Image from 'next/image';
import { trackEvent } from '@surfline/web-common';

import PremiumBadgeIcon from 'components/Icons/PremiumBadgeIcon';
import { useMaxWidthTablet } from 'hooks/useMediaQueries';

// @ts-expect-error Image can't be found on this path
import timeToScoreImage from '../../../public/images/paywalls/paywall-travel-time-to-score.png';
// @ts-expect-error Image can't be found on this path
import forecasterReportImage from '../../../public/images/paywalls/paywall-travel-forecaster-report.png';
// @ts-expect-error Image can't be found on this path
import seasonalReportImage from '../../../public/images/paywalls/paywall-travel-seasonal-report.png';

import styles from './PremiumTravelCTA.module.scss';

const PremiumTravelCTA: React.FC = () => {
  const isMobile = useMaxWidthTablet();
  const handleUpgradeClick = useCallback(() => {
    trackEvent('Clicked Subscribe CTA', {
      category: 'travel',
      location: 'when to score',
    });
  }, []);
  return (
    <Box className={classNames('sl-section-container', styles.wrapper)}>
      <Box className={styles.titleSection}>
        <Typography variant="title2" component="h2" className={styles.title}>
          {isMobile ? 'When to Score & Seasonal Surf Data' : 'Make sure to score during your trip'}
        </Typography>
        <PremiumBadgeIcon className={styles.premiumBadgeIconMobile} />
      </Box>
      <section className={styles.container}>
        <Box className={styles.header}>
          <Box className={styles.headerCopy}>
            <Typography variant="headline" component="h3" className={styles.headline}>
              Know exactly when to score — powered by our expert historical forecast data.
            </Typography>
            <Typography variant="body1" className={styles.subHeadline}>
              Decades of spot-specific swell info — combined with forecaster insights — show your
              best chance to score, found only on Surfline.
            </Typography>
          </Box>
          <Button
            href="/upgrade"
            variant="primary"
            size="large"
            className={styles.upgradeButton}
            onClick={handleUpgradeClick}
          >
            Upgrade
            <PremiumBadgeIcon className={styles.premiumBadgeIconDesktop} />
          </Button>
        </Box>
        <Box className={styles.content}>
          <Box className={styles.contentInner}>
            <Box className={styles.section}>
              <Typography variant="headline" component="h3" className={styles.sectionTitle}>
                Time to score
              </Typography>
              <Box className={styles.imageContainer}>
                <Image
                  src={timeToScoreImage}
                  alt="Time to score chart showing optimal surf conditions by month"
                  className={styles.sectionImage}
                  unoptimized
                  fill
                />
              </Box>
            </Box>
            <Box className={styles.section}>
              <Typography variant="headline" component="h3" className={styles.sectionTitle}>
                Forecaster reports
              </Typography>
              <Box className={styles.imageContainer}>
                <Image
                  src={forecasterReportImage}
                  alt="Forecaster report with expert insights and recommendations"
                  className={styles.sectionImage}
                  unoptimized
                  fill
                />
              </Box>
            </Box>
            <Box className={styles.section}>
              <Typography variant="headline" component="h3" className={styles.sectionTitle}>
                Seasonal Surf Data
              </Typography>
              <Box className={styles.imageContainer}>
                <Image
                  src={seasonalReportImage}
                  alt="Seasonal surf data showing wave height trends throughout the year"
                  className={styles.sectionImage}
                  unoptimized
                  fill
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </section>
    </Box>
  );
};

export default PremiumTravelCTA;
